export default __webpack_public_path__ + "static/media/coooo.add9b8f2.jpg";